// analog to $breakpoint-mobile
const isMobile = () => window.outerWidth <= 500
// analog to $breakpoint-tablet
const isTablet = () => window.outerWidth <= 930

export {isMobile, isTablet};
